"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOM = void 0;
var DOM;
(function (DOM) {
    class Parser {
        static getBodyElement() {
            const bodyElement = document.getElementsByTagName('body');
            if (bodyElement.length !== 1) {
                throw new Error(`DOM can't find body element`);
            }
            return bodyElement[0];
        }
        static getLocale() {
            const htmlElement = document.getElementsByTagName('html');
            if (htmlElement.length !== 1) {
                throw new Error(`DOM can't find html element`);
            }
            const lang = htmlElement[0].getAttribute('lang');
            if (lang !== 'en' && lang !== 'cs') {
                throw new Error(`Wrong localization on HTML element: ${lang}`);
            }
            return lang;
        }
        static getParentElement(element) {
            if (!element.parentElement) {
                throw new Error(`DOM can't find parent element`);
            }
            return element.parentElement;
        }
        static getHtmlElement(id, inside) {
            const element = inside ? inside.querySelector('#' + id) : document.getElementById(id);
            if (!element) {
                throw new Error(`DOM can't find element with id ${id}`);
            }
            return element;
        }
        static getHtmlElementOrNull(id, inside) {
            return inside ? inside.querySelector('#' + id) : document.getElementById(id);
        }
        static getHtmlElementByClass(className, inside) {
            let elements;
            if (inside) {
                elements = inside.getElementsByClassName(className);
            }
            else {
                elements = document.getElementsByClassName(className);
            }
            const element = elements ? elements.item(0) : null;
            if (!element) {
                throw new Error(`DOM can't find element with class ${className}`);
            }
            else {
                return element;
            }
        }
        static getHtmlInputElementValueByName(name, inside) {
            const element = inside
                ? inside.querySelector(`[name='${name}']`)
                : document.querySelector(`[name='${name}']`);
            if (element === null) {
                throw new Error(`DOM can't find element with name ${name}`);
            }
            return element.value.length > 0 ? element.value : null;
        }
        static getHtmlInputElementByName(name) {
            const elements = document.getElementsByName(name);
            if (elements.length === 0) {
                throw new Error(`DOM can't find elements with name ${name}`);
            }
            return elements[0];
        }
        static getHtmlElements(className, inside, ignoreEmpty = true) {
            const elements = inside ? inside.getElementsByClassName(className) : document.getElementsByClassName(className);
            if (!ignoreEmpty && elements.length === 0) {
                throw new Error(`DOM can't find elements with class ${className}`);
            }
            return elements;
        }
        static checkFormInvalid(form) {
            const elementsNotVerified = DOM.Parser.getHtmlElements('NOT_VERIFIED', form, true);
            const elementsNotFilled = DOM.Parser.getHtmlElements('NOT_FILLED', form, true);
            const elementsInvalid = form.querySelectorAll(`[data-valid='false']`);
            return (elementsNotVerified.length + elementsInvalid.length + elementsNotFilled.length) !== 0;
        }
        static getHtmlElementsByQuery(query, inside, mute = false) {
            const elements = inside ? inside.querySelectorAll(query) : document.querySelectorAll(query);
            if (!mute && elements.length === 0) {
                throw new Error(`DOM can't find elements with query ${query}`);
            }
            return elements;
        }
        static getHtmlElementByQuery(query, inside) {
            const elements = this.getHtmlElementsByQuery(query, inside, false);
            return elements[0];
        }
        static getHtmlElementAttribute(element, attributeName) {
            const attributeValue = element.getAttribute(attributeName);
            if (!attributeValue) {
                throw new Error(`DOM can't find attribute ${attributeName} on element`);
            }
            return attributeValue;
        }
        static getElementByTag(tagName, inside, mute = false) {
            let element;
            if (inside)
                element = inside.getElementsByTagName(tagName);
            else
                element = document.getElementsByTagName(tagName);
            if (!mute && element.length === 0) {
                throw new Error(`DOM can't find element with tag ${tagName}`);
            }
            return element[0];
        }
        static getDataByNameFromElement(dataName, element) {
            const dataValue = element.dataset[dataName];
            if (!dataValue) {
                throw new Error(`Missing data with key ${dataName} on element`);
            }
            return dataValue;
        }
        static getDataByNameFromElementOrNull(dataName, element) {
            const dataValue = element.dataset[dataName];
            return dataValue && dataValue.toString().trim().length > 0 ? dataValue : null;
        }
        static getElementsByDataName(dataName, element, mute = false) {
            return this.getHtmlElementsByQuery(`[data-${dataName}]`, element, mute);
        }
        static parentContainsTheClass(className, element) {
            if (!element.parentElement) {
                return false;
            }
            if (element.classList.contains(className)) {
                return true;
            }
            return this.parentContainsTheClass(className, element.parentElement);
        }
        static reInitializeElement(elementId) {
            let element = DOM.Parser.getHtmlElement(elementId);
            const elementParent = element.parentElement;
            if (elementParent === null) {
                throw new Error(`Missing parent on element`);
            }
            const elementCloned = element.cloneNode(true);
            element.remove();
            elementParent.append(elementCloned);
            return DOM.Parser.getHtmlElement(elementId);
        }
    }
    DOM.Parser = Parser;
})(DOM || (exports.DOM = DOM = {}));
